import React from 'react';
import CareersSection from '../components/CareersSection';
import { useTheme } from '../context/ThemeContext';

const CareersPage = () => {
  const { theme } = useTheme();

  return (
    <div className={`min-h-screen pt-20 md:pt-28 ${theme === 'dark' ? 'bg-black' : 'bg-gray-50'}`}>
      {/* Hero Image Section */}
      <div className="relative w-full h-[300px] sm:h-[400px] lg:h-[500px] overflow-hidden">
        <img 
          src="https://customer-assets.emergentagent.com/job_67218e68-4bb7-4a39-b578-c9fa413502c7/artifacts/j7t8nrsr_careet.webp"
          alt="Careers at RKS Technologies"
          className="w-full h-full object-cover"
        />
        <div className={`absolute inset-0 ${
          theme === 'dark' 
            ? 'bg-gradient-to-b from-black/60 via-black/30 to-black' 
            : 'bg-gradient-to-b from-gray-900/40 via-gray-900/20 to-gray-50'
        }`} />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center px-4">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
              Careers
            </h1>
            <p className="text-base sm:text-lg lg:text-xl text-white/80 max-w-2xl mx-auto">
              Join our talent network and advance your IT career
            </p>
          </div>
        </div>
      </div>
      
      <CareersSection />
    </div>
  );
};

export default CareersPage;
